import { render, staticRenderFns } from "./SnapshotsList.vue?vue&type=template&id=fb8b20ec&scoped=true&"
import script from "./SnapshotsList.vue?vue&type=script&lang=js&"
export * from "./SnapshotsList.vue?vue&type=script&lang=js&"
import style0 from "./SnapshotsList.vue?vue&type=style&index=0&id=fb8b20ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8b20ec",
  null
  
)

export default component.exports